import deliverySettings from './deliverySettings'
import images from './images'
import itemGroups from './itemGroups'
import items from './items'
import optionGroups from './optionGroups'
import options from './options'
import portions from './portions'
import qrCodes from './qrCodes'
import shopSettings from './shopSettings'

export default {
  deliverySettings,
  images,
  itemGroups,
  items,
  optionGroups,
  options,
  portions,
  qrCodes,
  shopSettings
}
